module.exports = __webpack_public_path__ + "img/loss.9d847514.svg";